(function($){
    if($('#new-resort').length > 0){
        $('#new-resort input:not([type="checkbox"]):not([type="radio"]), #new-resort select, #new-resort textarea').addClass('form-control')
    }
    if($('[data-key="field_614ed01c19f4d"]').length > 0){
        $('[data-key="field_614ed01c19f4d"] .file-info').each(function(){
           $(this).append('<a href="'+$(this).find('[data-name="filename"]').attr('href')+'" class="file-downloader">Pobierz</a>')
        })
    }
    if($('.acf-gallery-main').length > 0){
        $('[data-name="galeria_zdjec"]').append('<a href="'+$('body').attr('data-home-url')+'/download-resort-photos/'+$('.content-wrapper').attr('data-resort-id')+'/" class="download-photos">Pobierz wszystkie zdjęcia</a>');
        setInterval(function(){
            $('.acf-gallery-main, .acf-gallery-side').removeAttr('style');
            $('.acf-gallery-side, .acf-gallery-toolbar').remove();
            if($('.media-progress-bar-box').length > 0 || $('.acf-gallery-attachments .acf-gallery-attachment').length <= 0){
                $('.download-photos').remove();
            }
        }, 1);
        $('.acf-gallery .acf-gallery-attachment .margin').each(function(){
            $(this).append('<a href="'+$(this).find('img').attr('src')+'" download>Pobierz</a>')
        })
    }
    $('body').on('click', '.acf-gallery .acf-gallery-attachment .margin', function(e){
        // var imgid = $(this).closest('.acf-gallery-attachment').attr('data-id');
        // var imgsrc = $(this).find('img').attr('src');
        // $('body').append('<a href="'+imgsrc+'" id="remlink'+imgid+'" class="testyy" download>asdzxc</a>');
        // setTimeout(function(){
        //     $('body #remlink'+imgid).click();
        // }, 500)
        // $('#remlink'+imgid).remove();
        // alert();
        // e.preventDefault();
        // e.stopImmediatePropagation();
    })
    $('.acf-form').on('click', '[data-event="remove-row"]', function(e) {
        $(this).click();
    });
})(jQuery);